/* eslint-disable */
// FAMIS Script Studio — générateur de scripts BlueZone (.bbs) pour la time card FS-110.
// Repris de l'outil « famis-script-studio.html » (sans le testeur de scripts),
// monté dans la page « Script FAMIS » du site. Configuration gardée dans le
// navigateur (localStorage, comme l'outil d'origine) ; mots de passe jamais mémorisés.
/* ===================== Données ===================== */
const CODES = [
 ["000","Début de journée"],["001","Fin de journée"],["010","Début d'activité route"],["013","Début de pause non payée"],
 ["014","Fin de pause non payée"],["017","Fin d'activité route"],["019","Ramassage vrac (bulk pup)"],["020","Traitement matières dangereuses"],
 ["021","Changement de route"],["022","Activité de navette"],["023","Activité carburant (plein)"],["024","Véhicule HS"],
 ["025","Changement de véhicule"],["026","Retour d'un véhicule en service"],["028","Début de pause"],["029","Fin de pause"],
 ["030","Manutention"],["032","Activités caretaker/gatekeeper"],["034","Activités Office/Customer Service"],["035","Activité Dispatch"],
 ["036","Formation"],["037","Début de contrôle qualité (checkride)"],["039","Divers"],["041","Changement de site"],
 ["042","Changement de manager"],["046","Activité documentation import/export"],["048","Réunion"],["050","Activités de comptoirs"],
 ["060","Fin de contrôle qualité (checkride)"],["061","Tri des expéditions en enveloppes"],["065","Activité CMOD"],
 ["067-1","Traitement fret (manutention)"],["067-2","Traitement fret (documentation)"],["093","Traitement/recherche colis en exceptions"]
];
const EXTRA_DEFAULT = {"042":"2","067-1":"1","067-2":"2"};
const nc = (code,time,extra="",ask=false,askTime=false)=>({code,time,extra,ask,askTime});
const multiCodes = ()=>[];
const newUser = (name,mat)=>({name,mat,sched:"",act:"",end:"",askHours:false,open:false,codes:multiCodes()});

const DEFAULT = {
  view:"home",
  single:{autoLogin:true,loginId:"",pwdAsk:false,pwd:"",id2:"",pwd2Ask:false,pwd2:"",lag:"1",
    mat:"",dateMode:"today",date:"",sched:"",act:"",end:"",askHours:false,pressEnter:false,ui11:true,
    codes:[]},
  multi:{enterSelect:false,dateMode:"today",date:"",delay:"",ui11:true,
    users:[]}
};
/* anciennes configurations : dateAsk (case à cocher) -> dateMode */
function migrate(o){if(o&&o.dateMode===undefined&&o.dateAsk!==undefined)o.dateMode=o.dateAsk?"ask":"fixed";if(o&&o.ui11===undefined)o.ui11=true;}

let state;
const KEY="famis-script-studio-v1";
function load(){
  state = JSON.parse(JSON.stringify(DEFAULT));
  try{
    const s = JSON.parse(localStorage.getItem(KEY)||"null");
    if(s){ state.view=s.view||"home"; migrate(s.single);migrate(s.multi); Object.assign(state.single,s.single||{}); Object.assign(state.multi,s.multi||{}); }
  }catch(e){}
}
function save(){
  try{
    const c = JSON.parse(JSON.stringify(state));
    c.single.pwd=""; c.single.pwd2="";   // les mots de passe ne sont jamais mémorisés
    localStorage.setItem(KEY,JSON.stringify(c));
  }catch(e){}
}

/* ===================== Utilitaires ===================== */
let ROOT=null, TOAST=()=>{};
const $ = s=>ROOT.querySelector(s);
const esc = s=>String(s??"").replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const getP = p=>p.split(".").reduce((o,k)=>o==null?o:o[k],state);
function setP(p,v){const k=p.split(".");const l=k.pop();k.reduce((o,x)=>o[x],state)[l]=v;}
const clean = s=>String(s??"").normalize("NFD").replace(/[\u0300-\u036f]/g,"");
const bb = s=>'"'+clean(s).replace(/"/g,'""')+'"';
/* Texte pour les fenêtres : garde les accents via Chr(n) (le fichier .bbs reste en ASCII pur) */
const bbx = s=>{
  s=String(s??"").replace(/[–—]/g,"-").replace(/[’‘]/g,"'").replace(/[“”]/g,'"').replace(/…/g,"...").replace(/ /g," ");
  const parts=[];let buf="";
  const flush=()=>{if(buf){parts.push('"'+buf.replace(/"/g,'""')+'"');buf="";}};
  for(const ch of s){const c=ch.charCodeAt(0);
    if(c<128)buf+=ch; else if(c<256){flush();parts.push(`Chr(${c})`);} else buf+=clean(ch).replace(/[^\x20-\x7e]/g,"");}
  flush();return parts.length?parts.join(" & "):'""';
};
const todayMMJJ = ()=>{const d=new Date();return String(d.getMonth()+1).padStart(2,"0")+String(d.getDate()).padStart(2,"0");};
const padMat = m=>{m=String(m??"").trim();return /^\d+$/.test(m)&&m.length<10?m.padStart(10,"0"):m;};
const codeLabel = c=>(CODES.find(x=>x[0]===c)||[null,""])[1];
const badTime = t=>{ if(!/^\d{4}$/.test(t||""))return true; return +t.slice(0,2)>23 || +t.slice(2)>59; };
const badDate = d=>{ if(!/^\d{4}$/.test(d||""))return true; const m=+d.slice(0,2),j=+d.slice(2); return m<1||m>12||j<1||j>31; };
function toast(m){TOAST(m);}

/* ===================== Composants ===================== */
function field(label,path,o={}){
  const v=getP(path)??"";
  const bad=!v?"":(o.time&&badTime(v)?" bad":(o.date&&badDate(v)?" bad":""));
  return `<label class="f"><span>${label}</span><input ${o.pw?'type="password"':'type="text"'} class="${o.time||o.date?"t":""}${bad}" data-bind="${path}" value="${esc(v)}" ${o.max?`maxlength="${o.max}"`:""} placeholder="${esc(o.ph||"")}" ${o.time||o.date?'inputmode="numeric" maxlength="4"':""} autocomplete="off"></label>`;
}
function chk(label,path,hint="",big=false){
  return `<label class="chk${big?" big":""}"><input type="checkbox" data-bind="${path}" ${getP(path)?"checked":""}><span><b>${label}</b>${hint?`<br><span class="muted">${hint}</span>`:""}</span></label>`;
}
function codesTable(path){
  const list=getP(path);
  const rows=list.map((c,i)=>{
    const p=`${path}.${i}`;
    return `<tr>
      <td><select data-bind="${p}.code"><option value="" ${c.code?"":"selected"}>— Choisir un code —</option>${CODES.map(([k,d])=>`<option value="${k}" ${k===c.code?"selected":""}>${k} – ${esc(d)}</option>`).join("")}</select></td>
      <td><input type="text" class="t${c.time&&badTime(c.time)?" bad":""}" data-bind="${p}.time" value="${esc(c.time)}" maxlength="4" inputmode="numeric" placeholder="HHMM" title="Vide = heure de début (ACT)"></td>
      <td><input type="text" class="t" style="width:52px" data-bind="${p}.extra" value="${esc(c.extra)}" maxlength="4"></td>
      <td><label><input type="checkbox" data-bind="${p}.ask" ${c.ask?"checked":""}>Oui/Non</label></td>
      <td><label><input type="checkbox" data-bind="${p}.askTime" ${c.askTime?"checked":""}>Heure au lancement</label></td>
      <td><div class="acts">
        <button class="btn icon" data-act="up" data-list="${path}" data-i="${i}" title="Monter">↑</button>
        <button class="btn icon" data-act="down" data-list="${path}" data-i="${i}" title="Descendre">↓</button>
        <button class="btn icon del" data-act="delCode" data-list="${path}" data-i="${i}" title="Supprimer">✕</button></div></td></tr>`;
  }).join("");
  return `<div class="tw"><table><thead><tr><th>Code</th><th>Heure</th><th>Compl.</th><th>Demander</th><th></th><th></th></tr></thead>
    <tbody>${rows||`<tr><td colspan="6" class="muted">Aucun code — ajoutez-en un.</td></tr>`}</tbody></table></div>
    <div class="row" style="margin-top:10px">
      <button class="btn sm" data-act="addCode" data-list="${path}">+ Ajouter un code</button>
      <button class="btn ghost sm" data-act="sortCodes" data-list="${path}">Trier par heure</button>
    </div>
    <div class="hint"><b>Heure</b> vide = heure de début (ACT). <b>Compl.</b> = saisi juste après l'heure (ex : <code>042</code> + heure + <code>2</code>).
    <b>Oui/Non</b> : le script demandera « activité ? » au lancement (comme Dispatch / Comptoir). <b>Heure au lancement</b> : l'heure sera demandée au lancement.</div>`;
}
function hoursBlock(base){
  const ask=getP(base+".askHours");
  return `<div class="fields">
    ${ask?"":field("SCHD (prévu)",base+".sched",{time:1,ph:"HHMM"})+field("ACT (début)",base+".act",{time:1,ph:"HHMM"})+field("END (fin)",base+".end",{time:1,ph:"HHMM"})}
  </div>${chk("Demander les heures au lancement",base+".askHours","Le script demandera l'heure de début et de fin (SCHD = ACT = début). Valeurs actuelles proposées par défaut.")}`;
}
function dateBlock(base){
  const mode=getP(base+".dateMode")||"today";
  const opts=[["today","Date du jour automatique",`Saisie sans question (aujourd'hui : ${todayMMJJ()})`],
              ["ask","Demander au lancement","Fenêtre avec la date du jour déjà remplie"],
              ["fixed","Date fixe","Toujours la même date"]];
  return `<div class="f" style="margin-top:12px"><span>Date de la time card (MMJJ)</span></div>
  <div class="seg">${opts.map(([v,t,h])=>`<label><input type="radio" name="${base}-dm" data-bind="${base}.dateMode" value="${v}" ${mode===v?"checked":""}><span><b>${t}</b><small>${h}</small></span></label>`).join("")}</div>
  ${mode==="fixed"?`<div class="fields">${field("Date (MMJJ)",base+".date",{date:1,ph:"MMJJ"})}</div>`:""}
  ${mode==="today"?`<div class="hint">La date est calculée par le script <b>le jour où il est lancé</b> (horloge du PC) : le même fichier .bbs sert tous les jours.</div>`:""}`;
}
const dateShown=base=>{const m=getP(base+".dateMode");return m==="today"?todayMMJJ():m==="fixed"?getP(base+".date"):"";};
function uiBlock(base,multi){
  return `${chk("Fenêtres Windows 11","" + base + ".ui11","Fenêtres modernes affichées par mshta.exe, fourni avec Windows : rien à installer. Si le poste les bloque, le script repasse tout seul aux fenêtres classiques de BlueZone.")}
  <div class="prev"><span class="muted">Aperçu :</span>
    ${multi?`<button class="btn ghost sm" data-act="preview" data-k="pick" data-b="${base}">Sélection des personnes</button>`:""}
    <button class="btn ghost sm" data-act="preview" data-k="date" data-b="${base}">Date</button>
    <button class="btn ghost sm" data-act="preview" data-k="ask" data-b="${base}">Oui / Non</button>
    <button class="btn ghost sm" data-act="preview" data-k="time" data-b="${base}">Heure</button>
  </div>`;
}
function termPreview(u,date){
  const mat=(u.mat?padMat(u.mat):"MATRICULE").padEnd(10," ").slice(0,10);
  const d=(date||"MMJJ").padEnd(4).slice(0,4);
  const h=u.askHours?["????","????","????"]:[u.sched,u.act,u.end];
  const codes=u.codes.filter(c=>c.code).map(c=>`${c.code.slice(0,3)} ${c.askTime?"????":(c.time||(u.askHours?"????":u.act))}${c.extra?" "+c.extra:""}${c.ask?"?":""}`).join("  ");
  return `<div class="term">REQUEST ====> <b>A</b>
 FEDEX ID    DATE   ...   SCHD ACT  END
 <b>${esc(mat)}</b>  <b>${esc(d)}</b>   ...   <b>${esc(h.join(" "))}</b>

 VEHICLE:  CD TIME ...
 <b>${esc(codes)||"(aucun code)"}</b></div>`;
}
function outPanel(){
  return `<div class="out"><div class="card accent">
    <h3>Script généré <span class="pill" id="lc"></span></h3>
    <div class="row">
      <input type="text" id="fname" style="flex:1;min-width:160px" value="${esc(state.view==="single"?"FAMIS_"+(state.single.mat||state.single.loginId||"utilisateur"):"FAMIS_multi_utilisateurs")}">
      <button class="btn" data-act="dl">⬇ Télécharger .bbs</button>
      <button class="btn pu" data-act="copy">Copier</button>
    </div>
    <div id="warns"></div>
    <pre class="code" id="code"></pre>
    <div class="hint">Dans BlueZone 7.10 : ouvrez l'écran <b>FS-110 TIME CARD MAINTENANCE</b> (sauf avec connexion auto), puis <i>Script › Play</i> et choisissez le fichier .bbs.<br>Les fenêtres Windows 11 sont créées par le script lui-même (fichier temporaire dans %TEMP%, ouvert par <code>mshta.exe</code> de Windows) : <b>rien à installer</b>.</div>
  </div></div>`;
}

/* ===================== Vues ===================== */
function renderHome(){
  $("#famis-app").innerHTML=`<div class="hero"><h1>Que voulez-vous <span>générer</span> ?</h1>
    <div class="muted">Créez vos scripts BlueZone pour FAMIS sans écrire une ligne de code.</div></div>
  <div class="choices">
    <div class="choice" data-act="goto" data-view="single">
      <div class="ic"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#4D148C" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg></div>
      <h2>Script utilisateur seul</h2><div class="muted">Une feuille de temps pour une personne</div>
      <ul><li>Connexion automatique à FAMIS (optionnelle)</li><li>Codes d'activité + heures</li><li>Questions au lancement (Dispatch, comptoir…)</li></ul>
    </div>
    <div class="choice" data-act="goto" data-view="multi">
      <div class="ic"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#FF6200" stroke-width="2"><circle cx="9" cy="8" r="3.5"/><circle cx="17" cy="9" r="2.8"/><path d="M2 20c0-3.5 3.2-5.5 7-5.5s7 2 7 5.5M16 14.5c3 0 6 1.5 6 5"/></svg></div>
      <h2>Script multi-utilisateur</h2><div class="muted">CDI, intérims, équipes</div>
      <ul><li>Liste d'utilisateurs (nom + matricule)</li><li>Menu à cases à cocher au lancement</li><li>Saisie à la suite des personnes cochées</li></ul>
    </div>
  </div>`;
}
function renderSingle(){
  const s=state.single;
  $("#famis-app").innerHTML=`<div class="top"><div><h2>Script utilisateur seul</h2><div class="muted">Connexion automatique (optionnelle) + saisie de la time card</div></div>
    <button class="btn ghost" data-act="goto" data-view="home">← Accueil</button></div>
  <div class="grid"><div>
    <div class="card">
      <h3>Connexion</h3>
      ${chk("Connexion automatique","single.autoLogin","Le script se connecte à FAMIS, ouvre la route 110 puis saisit la feuille de temps. Décoché : le script démarre directement à la saisie « a » sur l'écran FS-110.",true)}
      ${s.autoLogin?`<div class="fields" style="margin-top:12px">
        ${field("Identifiant (écran 1)","single.loginId",{ph:"Matricule"})}
        ${s.pwdAsk?"":field("Mot de passe (écran 1)","single.pwd",{pw:1,ph:"Mot de passe"})}
        ${field("Identifiant (écran 2)","single.id2",{ph:"Matricule"})}
        ${s.pwd2Ask?"":field("Mot de passe (écran 2)","single.pwd2",{pw:1,ph:"Mot de passe"})}
      </div>
      ${chk("Demander le mot de passe 1 au lancement","single.pwdAsk","Recommandé : le mot de passe n'est pas écrit en clair dans le fichier .bbs.")}
      ${chk("Demander le mot de passe 2 au lancement","single.pwd2Ask")}
      <label class="f" style="max-width:340px;margin-top:6px"><span>Délais entre les saisies (latence)</span>
        <select data-bind="single.lag">${[["1","Normal (≈ 20 s de connexion)"],["1.5","Lent (x1,5)"],["2","Très lent (x2)"],["3","Réseau très chargé (x3)"]].map(([v,l])=>`<option value="${v}" ${String(s.lag||"1")===v?"selected":""}>${l}</option>`).join("")}</select></label>
      <div class="hint">Pause après chaque frappe de la connexion (identifiant, Tab, mot de passe, Entrée, 45, 110, F4, F6). Augmentez si FAMIS rate des saisies.</div>
      <div class="hint">🔒 Les mots de passe ne sont jamais mémorisés par cette page (à ressaisir à chaque ouverture).</div>`:""}
    </div>
    <div class="card">
      <h3>Feuille de temps</h3>
      <div class="fields">
        ${field("Matricule (FEDEX ID)","single.mat",{ph:"Matricule",max:10})}
        <div class="hint" style="grid-column:1/-1;margin:0">Sur la time card, le matricule est complété automatiquement par des 0 à gauche pour faire 10 chiffres. La connexion utilise le matricule tel quel.</div>
      </div>
      ${dateBlock("single")}
      ${hoursBlock("single")}
      ${chk("Valider automatiquement (Entrée)","single.pressEnter","Décoché : le script remplit l'écran et vous laisse vérifier avant d'appuyer sur Entrée.")}
      ${termPreview({...s,mat:s.mat||s.loginId},dateShown("single"))}
    </div>
    <div class="card"><h3>Fenêtres</h3>${uiBlock("single",false)}</div>
    <div class="card"><h3>Codes d'activité</h3>${codesTable("single.codes")}</div>
  </div>${outPanel()}</div>`;
}
function renderMulti(){
  const m=state.multi;
  const users=m.users.map((u,i)=>`<div class="ucard">
    <div class="uhead" data-act="toggleUser" data-i="${i}">
      <span class="num">${i+1}</span>
      <span class="nm"><span data-title="${i}">${esc(u.name||"(sans nom)")}<small>${esc(u.mat)}</small></span></span>
      <span class="muted">${u.codes.length} code(s)</span>
      <button class="btn icon" data-act="uUp" data-i="${i}" title="Monter">↑</button>
      <button class="btn icon" data-act="uDown" data-i="${i}" title="Descendre">↓</button>
      <button class="btn icon del" data-act="delUser" data-i="${i}" title="Supprimer">✕</button>
      <span style="color:var(--pu);font-weight:800">${u.open?"▾":"▸"}</span>
    </div>
    ${u.open?`<div class="ubody">
      <div class="fields">${field("Nom","multi.users."+i+".name",{ph:"Nom"})}${field("Matricule","multi.users."+i+".mat",{max:10,ph:"Matricule"})}</div>
      <div style="margin-top:12px">${hoursBlock("multi.users."+i)}</div>
      <h3 style="margin-top:14px">Codes d'activité</h3>
      ${codesTable("multi.users."+i+".codes")}
      <div class="row" style="margin-top:10px"><button class="btn ghost sm" data-act="copyCodes" data-i="${i}">Copier ces codes et heures à tous les utilisateurs</button></div>
      ${termPreview(u,dateShown("multi"))}
    </div>`:""}
  </div>`).join("");
  $("#famis-app").innerHTML=`<div class="top"><div><h2>Script multi-utilisateur</h2><div class="muted">Menu à cases à cocher : les personnes cochées sont saisies à la suite</div></div>
    <button class="btn ghost" data-act="goto" data-view="home">← Accueil</button></div>
  <div class="grid"><div>
    <div class="card">
      <h3>Options</h3>
      <div class="hint" style="margin:0 0 6px">Au lancement, une fenêtre liste tous les utilisateurs avec une case à cocher (et « Tout sélectionner »). Les personnes cochées sont saisies <b>l'une après l'autre, dans l'ordre de la liste</b>, et chaque fiche est validée par Entrée.</div>
      ${chk("Valider (Entrée) aussi quand une seule personne est cochée","multi.enterSelect","Décoché : avec une seule personne, l'écran est rempli et vous vérifiez avant d'appuyer sur Entrée.")}
      ${dateBlock("multi")}
      <div class="fields">${field("Attente après Entrée (s)","multi.delay",{ph:"4.4 par défaut"})}</div>
    </div>
    <div class="card"><h3>Fenêtres</h3>${uiBlock("multi",true)}</div>
    <div class="card">
      <h3>Ajouter un utilisateur</h3>
      <div class="row">
        <input type="text" id="nName" placeholder="Nom" style="flex:1;min-width:140px">
        <input type="text" id="nMat" placeholder="Matricule" maxlength="10" style="flex:1;min-width:140px">
        <button class="btn" data-act="addUser">+ Ajouter</button>
      </div>
      <div class="hint">Ajoutez ensuite ses heures et ses codes d'activité. Le matricule est complété automatiquement par des 0 dans le script (10 chiffres).</div>
    </div>
    <h3>Utilisateurs (${m.users.length})</h3>
    ${users||`<div class="card muted">Aucun utilisateur pour l'instant : ajoutez-en avec le formulaire ci-dessus.</div>`}
  </div>${outPanel()}</div>`;
}
function render(){
  const v=state.view;
  if(v==="single")renderSingle(); else if(v==="multi")renderMulti(); else renderHome();
  if(v==="single"||v==="multi")regen();
}

/* ===================== Génération du script ===================== */
function Gen(){this.l=[];}
Gen.prototype.a=function(ind,s){this.l.push(" ".repeat(ind)+s);};

/* ---------- Fenêtre Windows 11 écrite par le script (HTA lancé par mshta.exe, inclus dans Windows) ----------
   ES5 uniquement (moteur IE11 de mshta), ASCII uniquement (accents en entités HTML / é). */
const HTA_SRC=String.raw`<!DOCTYPE html>
<html>
<head>
<meta http-equiv="x-ua-compatible" content="ie=edge">
<title>FAMIS</title>
<hta:application id="app" applicationname="FamisScriptUI" border="dialog" borderstyle="normal" caption="yes" contextmenu="no" innerborder="no" maximizebutton="no" minimizebutton="no" navigable="no" scroll="no" selection="no" showintaskbar="yes" singleinstance="no" sysmenu="yes">
<script>try{window.resizeTo(460,320);window.moveTo(-4000,-4000);}catch(e){}</scr${""}ipt>
<style>
html,body{margin:0;padding:0;overflow:hidden;background:#fff}
body{font-family:'Segoe UI Variable Text','Segoe UI',Tahoma,sans-serif;font-size:14px;color:#1b1b1b;cursor:default;-ms-user-select:none}
.c{padding:22px 24px 20px}
.hd{overflow:hidden;margin-bottom:10px}
.ic{float:left;width:32px;height:32px;line-height:32px;text-align:center;border-radius:16px;background:#e6f0fa;color:#005fb8;font-family:'Segoe Fluent Icons','Segoe MDL2 Assets';font-size:15px;margin-right:12px}
.info .ic{background:#dff6dd;color:#0f7b0f}
h1{margin:0;font-family:'Segoe UI Variable Display','Segoe UI',sans-serif;font-size:20px;font-weight:600;line-height:32px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
p{margin:0 0 14px;line-height:20px}
.tb{display:block;width:100%;box-sizing:border-box;height:34px;padding:0 11px;font-family:'Segoe UI Variable Text','Segoe UI',sans-serif;font-size:14px;color:#1b1b1b;background:#fff;border:1px solid #e5e5e5;border-bottom:1px solid #8a8a8a;border-radius:4px;outline:none}
.tb:hover{background:#f9f9f9}
.tb:focus{background:#fff;border-bottom:2px solid #005fb8}
.tb.bad{border-bottom:2px solid #c42b1c}
.hl{height:18px;margin-top:6px;font-size:12px;color:#5d5d5d}
.hl.bad{color:#c42b1c}
.ft{background:#f3f3f3;border-top:1px solid #e5e5e5;padding:20px 24px;overflow:hidden}
button{font-family:'Segoe UI Variable Text','Segoe UI',sans-serif;font-size:14px;height:32px;width:49%;border-radius:4px;border:1px solid #d0d0d0;border-bottom-color:#bcbcbc;background:#fbfbfb;color:#1b1b1b;outline:none;cursor:default}
button:hover{background:#f6f6f6}
button:active{background:#f0f0f0;color:#5d5d5d}
button.pri{background:#005fb8;border-color:#0067c0;border-bottom-color:#003e92;color:#fff}
button.pri:hover{background:#196ebf}
button.pri:active{background:#3183ca;color:#dbe7f5}
button[disabled],button.pri[disabled]{background:#f0f0f0;border-color:#e5e5e5;color:#a0a0a0}
#b1{float:left}
#b2{float:right}
.one #b1{float:right}
.all,.it{padding:7px 8px;border-radius:4px;overflow:hidden;white-space:nowrap;outline:none}
.all{border-bottom:1px solid #ebebeb;margin-bottom:4px}
.all:hover,.it:hover{background:#f5f5f5}
.all:focus,.it:focus{background:#eef4fb}
.cb{float:left;width:18px;height:18px;box-sizing:border-box;border:1px solid #8a8a8a;border-radius:4px;background:#fafafa;margin:1px 12px 0 0;font-family:'Segoe Fluent Icons','Segoe MDL2 Assets';font-size:11px;line-height:16px;text-align:center;color:#fff}
.on .cb,.mix .cb{background:#005fb8;border-color:#005fb8}
.no{float:left;width:20px;line-height:20px;color:#8a8a8a;font-size:12px}
.nm{float:left;line-height:20px;max-width:240px;overflow:hidden;text-overflow:ellipsis}
.mt,.cnt{float:right;line-height:20px;color:#5d5d5d;font-size:12px}
.mt{font-family:Consolas,monospace}
.lst{max-height:272px;overflow-x:hidden;overflow-y:auto}
</style>
</head>
<body>
<div id="c" class="c"><div class="hd"><span id="ic" class="ic"></span><h1 id="h"></h1></div><p id="m"></p><div id="z"></div></div>
<div id="ft" class="ft"><button id="b1" class="pri" onclick="go()">OK</button><button id="b2" onclick="no()">Annuler</button></div>
<script>
var BS=String.fromCharCode(92),NL=String.fromCharCode(13)+String.fromCharCode(10);
var fso=null,sh=null,dir='',OUT='',P=[];
try{fso=new ActiveXObject('Scripting.FileSystemObject');sh=new ActiveXObject('WScript.Shell');dir=sh.ExpandEnvironmentStrings('%TEMP%');OUT=dir+BS+'famis_ui_out.txt';
var f=fso.OpenTextFile(dir+BS+'famis_ui_in.txt',1,false,0);P=f.ReadAll().split(String.fromCharCode(10));f.Close();}catch(e){}
for(var i=0;i<P.length;i++){P[i]=P[i].split(String.fromCharCode(13)).join('');}
function wr(s){try{var t=fso.CreateTextFile(OUT,true,false);t.Write(s);t.Close();}catch(e){}}
wr('CANCEL'+NL);
var K=P[0]||'info',TT=P[1]||'FAMIS',MS=P[2]||'',DF=P[3]||'',IT=P[4]||'',I=null,S=[],tried=false;
var MO=['janvier','f\u00e9vrier','mars','avril','mai','juin','juillet','ao\u00fbt','septembre','octobre','novembre','d\u00e9cembre'];
var JO=['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
function $(i){return document.getElementById(i);}
function tx(s){var d=document.createElement('div');d.innerText=s;return d.innerHTML;}
function isIn(){return K=='input'||K=='time'||K=='date'||K=='pwd';}
function chk(v){
if(K=='time'){if(!/^\d{4}$/.test(v))return 'Format HHMM attendu (ex : 0830)';if(+v.substr(0,2)>23||+v.substr(2,2)>59)return 'Heure invalide (0000 \u00e0 2359)';}
if(K=='date'){if(!/^\d{4}$/.test(v))return 'Format MMJJ attendu (ex : 1028)';var m=+v.substr(0,2),j=+v.substr(2,2);if(m<1||m>12||j<1||j>31)return 'Date invalide';}
if(K=='pwd'&&!v)return 'Mot de passe obligatoire';
return '';}
function hint(){
if(!I)return;var v=I.value,e=chk(v),h='',hl=$('hl'),bad=!!e&&(tried||v.length>=4);
if(!e&&K=='time')h='\u2192 '+v.substr(0,2)+':'+v.substr(2,2);
if(!e&&K=='date'){var y=new Date().getFullYear(),d=new Date(y,+v.substr(0,2)-1,+v.substr(2,2));h=JO[d.getDay()]+' '+d.getDate()+' '+MO[d.getMonth()]+' '+y;h='\u2192 '+h.charAt(0).toUpperCase()+h.substr(1);}
if(e&&!bad)h=K=='time'?'Format HHMM, ex : 0830':K=='date'?'Format MMJJ, ex : 1028':'';
hl.className=bad?'hl bad':'hl';I.className=bad?'tb bad':'tb';hl.innerText=bad?e:h;}
function cnt(){var n=0;for(var i=0;i<S.length;i++)if(S[i])n++;return n;}
function upd(){var n=cnt(),i;
for(i=0;i<S.length;i++){$('it'+i).className=S[i]?'it on':'it';$('cb'+i).innerHTML=S[i]?'&#xE73E;':'';}
$('all').className=n==0?'all':(n==S.length?'all on':'all mix');$('cba').innerHTML=n==0?'':(n==S.length?'&#xE73E;':'&#xE738;');
$('cnt').innerText=n+' / '+S.length;$('b1').innerText=n?'Saisir ('+n+')':'Saisir';$('b1').disabled=!n;}
function tg(i){S[i]=!S[i];upd();}
function ta(){var v=cnt()<S.length;for(var i=0;i<S.length;i++)S[i]=v;upd();}
function pickInit(){
var L=IT?IT.split('|'):[],h='';
for(var i=0;i<L.length;i++){var p=L[i].split(';');S.push(DF.charAt(i)=='1');
h+='<div class="it" id="it'+i+'" tabindex="0" onclick="tg('+i+')"><span class="cb" id="cb'+i+'"></span><span class="no">'+(i+1)+'</span><span class="nm">'+tx(p[0])+'</span><span class="mt">'+tx(p[1]||'')+'</span></div>';}
$('z').innerHTML='<div id="all" class="all" tabindex="0" onclick="ta()"><span class="cb" id="cba"></span><span class="nm"><b>Tout s&eacute;lectionner</b></span><span class="cnt" id="cnt"></span></div><div id="lst" class="lst">'+h+'</div>';
upd();}
function done(v){wr('OK'+NL+v+NL);window.close();}
function go(){
if(isIn()){tried=true;if(chk(I.value)){hint();I.focus();return;}done(I.value);}
else if(K=='ask')done('6');
else if(K=='pick'){if(!cnt())return;var s='';for(var i=0;i<S.length;i++)s+=S[i]?'1':'0';done(s);}
else done('1');}
function no(){if(K=='ask')done('7');else if(K=='info')done('1');else window.close();}
document.onkeydown=function(){var e=window.event,k=e.keyCode,a=document.activeElement,id=(a&&a.id)||'';
if(k==13){go();return false;}
if(k==27){no();return false;}
if(K=='pick'){
if(k==32){if(id=='all')ta();else if(id.indexOf('it')==0)tg(+id.substr(2));return false;}
if(k==40||k==38){var c=id=='all'?-1:(id.indexOf('it')==0?+id.substr(2):-2),n=c+(k==40?1:-1);if(n<-1)n=-1;if(n>=S.length)n=S.length-1;(n<0?$('all'):$('it'+n)).focus();return false;}
if(k==65&&e.ctrlKey){ta();return false;}}};
function fit(){var w=460;try{window.resizeTo(w,400);var ch=400-document.documentElement.clientHeight,H=$('c').offsetHeight+$('ft').offsetHeight+ch;window.resizeTo(w,H);
window.moveTo(Math.max(0,Math.round((screen.availWidth-w)/2)),Math.max(0,Math.round((screen.availHeight-H)/2.5)));}catch(e){}}
function init(){
var ic={input:'E70F',time:'E823',date:'E787',pwd:'E72E',ask:'E897',pick:'E716',info:'E73E'}[K]||'E946';
document.body.className=K;$('ic').innerHTML='&#x'+ic+';';$('h').innerText=TT;
if(MS)$('m').innerText=MS;else $('m').style.display='none';
if(isIn()){
$('z').innerHTML='<input id="I" class="tb" type="'+(K=='pwd'?'password':'text')+'"'+(K=='time'||K=='date'?' maxlength="4"':'')+' autocomplete="off"><div id="hl" class="hl"></div>';
I=$('I');I.value=DF;I.onkeyup=hint;
if(K=='time'||K=='date')I.onkeypress=function(){var c=window.event.keyCode;if(c!=13&&(c<48||c>57))return false;};
hint();}
else if(K=='ask'){$('b1').innerText='Oui';$('b2').innerText='Non';}
else if(K=='pick')pickInit();
else{$('b2').style.display='none';$('ft').className='ft one';}
fit();
setTimeout(function(){try{window.focus();if(I){I.focus();I.select();}else if(K=='pick')$('all').focus();else $('b1').focus();}catch(e){}},80);}
window.onload=init;
</scr${""}ipt>
</body>
</html>`;

/* Fonctions BlueZone Basic ajoutées en tête du script (avant Sub Main) */
function uiHelpers(G){
  const A=s=>G.a(0,s);
  A("' ===== Fenetres Windows 11 =====");
  A("' Affichees par mshta.exe (fourni avec Windows). Si mshta est bloque sur le poste,");
  A("' le script utilise automatiquement les fenetres classiques InputBox / MsgBox.");
  A("Sub UiInit");
  A("  On Error Resume Next");
  A('  uiOk = "0"');
  A('  Set uiSh = CreateObject("WScript.Shell")');
  A('  Set uiFso = CreateObject("Scripting.FileSystemObject")');
  A('  uiDir = uiSh.ExpandEnvironmentStrings("%TEMP%")');
  A('  Set t = uiFso.CreateTextFile(uiDir & "\\famis_ui.hta", True)');
  HTA_SRC.split("\n").forEach(l=>A('  t.WriteLine "'+l.replace(/"/g,'""')+'"'));
  A("  t.Close");
  A('  If Err.Number = 0 Then uiOk = "1"');
  A("End Sub");
  A("");
  A("Function UiShow(kind, titre, texte, defaut, items)");
  A("  On Error Resume Next");
  A('  UiShow = ""');
  A('  If uiOk = "" Then UiInit');
  A('  If uiOk <> "1" Then Exit Function');
  A('  uiFso.DeleteFile uiDir & "\\famis_ui_out.txt"');
  A("  Err.Clear");
  A('  Set t = uiFso.CreateTextFile(uiDir & "\\famis_ui_in.txt", True)');
  A("  t.WriteLine kind");
  A("  t.WriteLine titre");
  A("  t.WriteLine texte");
  A("  t.WriteLine defaut");
  A("  t.WriteLine items");
  A("  t.Close");
  A('  uiSh.Run "mshta.exe """ & uiDir & "\\famis_ui.hta""", 1, True');
  A('  If Not uiFso.FileExists(uiDir & "\\famis_ui_out.txt") Then');
  A('    uiOk = "0"');
  A("    Exit Function");
  A("  End If");
  A('  Set t = uiFso.OpenTextFile(uiDir & "\\famis_ui_out.txt", 1)');
  A("  r = t.ReadLine");
  A('  v = ""');
  A("  If Not t.AtEndOfStream Then v = t.ReadLine");
  A("  t.Close");
  A('  If r = "OK" Then');
  A('    UiShow = "OK" & v');
  A("  Else");
  A('    UiShow = "X"');
  A("  End If");
  A("End Function");
  A("");
  A("' Saisie de texte. kind = input / time / date / pwd. Annuler arrete le script.");
  A("Function UiInput(kind, titre, texte, defaut)");
  A('  r = UiShow(kind, titre, texte, defaut, "")');
  A('  If r = "" Then');
  A("    UiInput = InputBox(texte, titre, defaut)");
  A('  ElseIf r = "X" Then');
  A("    End");
  A("  Else");
  A("    UiInput = Mid(r, 3)");
  A("  End If");
  A("End Function");
  A("");
  A("' Question Oui / Non : renvoie 6 (Oui) ou 7 (Non), comme MsgBox.");
  A("Function UiAsk(titre, texte)");
  A('  r = UiShow("ask", titre, texte, "", "")');
  A('  If r = "" Then');
  A("    UiAsk = MsgBox(texte, 36, titre)");
  A('  ElseIf r = "OK6" Then');
  A("    UiAsk = 6");
  A("  Else");
  A("    UiAsk = 7");
  A("  End If");
  A("End Function");
  A("");
  A("' Liste a cocher : renvoie une suite de 0/1 (ex : 1011). Annuler arrete le script.");
  A("Function UiPick(titre, texte, items, liste, n)");
  A('  r = UiShow("pick", titre, texte, "", items)');
  A('  If r = "X" Then End');
  A('  If r <> "" Then');
  A("    UiPick = Mid(r, 3)");
  A("    Exit Function");
  A("  End If");
  A('  x = InputBox(liste & "   -   Numeros separes par des virgules (ex : 1,3) ou T pour tous :", titre, "T")');
  A('  y = ","');
  A("  For i = 1 To Len(x)");
  A("    ch = Mid(x, i, 1)");
  A('    If ch = ";" Or ch = "." Or ch = "-" Then ch = ","');
  A('    If ch <> " " Then y = y & ch');
  A("  Next i");
  A('  y = UCase(y) & ","');
  A('  s = ""');
  A("  For i = 1 To n");
  A('    If y = ",T," Or InStr(y, "," & i & ",") > 0 Then');
  A('      s = s & "1"');
  A("    Else");
  A('      s = s & "0"');
  A("    End If");
  A("  Next i");
  A("  UiPick = s");
  A("End Function");
  A("");
  A("' Message d'information (bouton OK).");
  A("Sub UiInfo(titre, texte)");
  A('  r = UiShow("info", titre, texte, "", "")');
  A('  If r = "" Then MsgBox texte, 64, titre');
  A("End Sub");
  A("");
}

function header(G,mode,ui11){
  const d=new Date();
  G.a(0,"'");
  G.a(0,`' ${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}:00 ${d.toLocaleDateString("fr-FR")}`);
  G.a(0,"' Script genere par FAMIS Script Studio - "+mode);
  G.a(0,"' BlueZone 7.10 - fenetres "+(ui11?"Windows 11 (mshta.exe)":"classiques"));
  G.a(0,"'");G.a(0,"");
  G.a(0,"Dim coco As Object");
  G.a(0,"Dim uiOk As String");
  G.a(0,"Dim uiDir As String");
  G.a(0,"Dim uiSh As Object");
  G.a(0,"Dim uiFso As Object");
  G.a(0,"");
  uiHelpers(G);
  G.a(0,"Sub Main");G.a(0,"");
  G.a(2,'set coco = CreateObject("BZWhll.WhllObj")');
  G.a(2,'coco.Connect ""');
  if(!ui11)G.a(2,'uiOk = "0"   \' fenetres classiques InputBox / MsgBox');
}
/* Renvoie l'expression Basic de la date ; écrit les lignes nécessaires */
function dateLines(G,ind,mode,fixed){
  if(mode==="fixed")return bb(fixed);
  G.a(ind,"' Date du jour au format MMJJ (horloge du PC)");
  G.a(ind,'auj = Right("0" & Month(Date), 2) & Right("0" & Day(Date), 2)');
  if(mode==="ask")G.a(ind,`myDate = UiInput("date", "Date de la time card", ${bbx("Date à saisir au format MMJJ (aujourd'hui proposé)")}, auj)`);
  else G.a(ind,"myDate = auj");
  return "myDate";
}
function prompts(G,u,tag,ind){
  const ttl=bbx(u.name||"Feuille de temps"), defT=c=>c.time?bb(c.time):(u.askHours?`hd_${tag}`:bb(u.act));
  if(u.askHours){
    G.a(ind,`hd_${tag} = UiInput("time", ${ttl}, ${bbx("Heure de début de journée (HHMM)")}, ${bb(u.act)})`);
    G.a(ind,`hf_${tag} = UiInput("time", ${ttl}, ${bbx("Heure de fin de journée (HHMM)")}, ${bb(u.end)})`);
  }
  u.codes.forEach((c,i)=>{
    if(!c.code)return;
    const v=`${tag}_${i+1}`, lbl=`${c.code} « ${codeLabel(c.code)} »`;
    if(c.ask){
      G.a(ind,`c_${v} = UiAsk(${ttl}, ${bbx("Saisir le code "+lbl+" ?")})`);
      if(c.askTime){
        G.a(ind,`t_${v} = ""`);
        G.a(ind,`If c_${v} = 6 Then`);
        G.a(ind+3,`t_${v} = UiInput("time", ${ttl}, ${bbx("Heure du code "+lbl+" (HHMM)")}, ${defT(c)})`);
        G.a(ind,"End If");
      }
    }else if(c.askTime){
      G.a(ind,`t_${v} = UiInput("time", ${ttl}, ${bbx("Heure du code "+lbl+" (HHMM)")}, ${defT(c)})`);
    }
  });
}
function entry(G,u,tag,ind,dateExpr,enter,delay){
  const deb=u.askHours?`hd_${tag}`:bb(u.act), sch=u.askHours?`hd_${tag}`:bb(u.sched), fin=u.askHours?`hf_${tag}`:bb(u.end);
  const K=s=>G.a(ind,"coco.SendKey "+s), C=(r,c)=>G.a(ind,`coco.SetCursor ${r}, ${c}`);
  const d=parseFloat(String(delay).replace(",","."))||4.4;
  G.a(ind,`' --- ${clean(u.name||"")} ${padMat(u.mat)} ---`);
  C(2,16);K('"a"');
  C(5,2);K('"          "');C(5,2);K(bb(padMat(u.mat)));
  C(5,13);K(dateExpr);
  C(5,47);K(sch);C(5,52);K(deb);C(5,57);K(fin);
  C(14,3);
  u.codes.forEach((c,i)=>{
    if(!c.code)return;
    const v=`${tag}_${i+1}`;let ci=ind;
    if(c.ask){G.a(ind,`If c_${v} = 6 Then`);ci=ind+3;}
    const tm=c.askTime?`t_${v}`:(c.time?bb(c.time):deb);
    G.a(ci,"coco.SendKey "+bb(c.code.slice(0,3)));
    G.a(ci,"coco.SendKey "+tm);
    if(c.extra)G.a(ci,"coco.SendKey "+bb(c.extra));
    G.a(ci,'coco.SendKey "<Tab>"');
    if(c.ask)G.a(ind,"End If");
  });
  if(enter==="multi"){
    G.a(ind,"If nb > 1 Then");
    G.a(ind+3,"coco.Wait 2.0");G.a(ind+3,'coco.SendKey "<Enter>"');G.a(ind+3,"coco.Wait "+d);
    G.a(ind,"End If");
  }else if(enter){G.a(ind,"coco.Wait 2.0");K('"<Enter>"');G.a(ind,"coco.Wait "+d);}
}
function genSingle(W){
  const s=state.single,G=new Gen();
  const u={...s,name:"",mat:s.mat||s.loginId};
  header(G,"utilisateur seul",s.ui11!==false);
  if(s.autoLogin&&!s.loginId)W.push("Identifiant de connexion vide.");
  if(s.autoLogin&&!s.pwdAsk&&!s.pwd)W.push("Mot de passe 1 vide (ou cochez « demander au lancement »).");
  if(s.autoLogin&&!s.pwd2Ask&&!s.pwd2)W.push("Mot de passe 2 vide (ou cochez « demander au lancement »).");
  if(s.dateMode==="fixed"&&badDate(s.date))W.push("Date invalide (format MMJJ).");
  checkUser(u,W,"");
  G.a(0,"");G.a(2,"' ===== Questions =====");
  const dateExpr=dateLines(G,2,s.dateMode||"today",s.date);
  if(s.autoLogin&&s.pwdAsk)G.a(2,`pwd1 = UiInput("pwd", "Connexion FAMIS", ${bbx("Mot de passe (écran 1)")}, "")`);
  if(s.autoLogin&&s.pwd2Ask)G.a(2,`pwd2 = UiInput("pwd", "Connexion FAMIS", ${bbx("Mot de passe (écran 2)")}, "")`);
  prompts(G,u,"u",2);
  if(s.autoLogin){
    G.a(0,"");G.a(2,"' ===== Connexion automatique =====");
    const m=parseFloat(s.lag)||1;
    const K=x=>G.a(2,"coco.SendKey "+x),Wt=x=>G.a(2,"coco.Wait "+String(Math.round(x*m*10)/10).replace(",","."));
    G.a(2,"' Ecran 1 : identifiant + mot de passe");
    K(bb(s.loginId));Wt(0.5);K('"<Tab>"');Wt(0.5);K(s.pwdAsk?"pwd1":bb(s.pwd));Wt(1);K('"<Enter>"');Wt(3);
    G.a(2,"' Menu : option 45");
    K('"45"');Wt(0.5);K('"<Enter>"');Wt(2.5);
    G.a(2,"' Ecran 2 : identifiant + mot de passe");
    K(bb(s.id2||s.loginId));Wt(0.5);K('"<Tab>"');Wt(0.5);K(s.pwd2Ask?"pwd2":bb(s.pwd2));Wt(1);K('"<Enter>"');Wt(3);
    G.a(2,"' Route 110");
    K('"110"');Wt(1);K('"<F4>"');Wt(1);K('"<F6>"');Wt(3);
  }
  G.a(0,"");G.a(2,"' ===== Saisie time card =====");
  entry(G,u,"u",2,dateExpr,s.pressEnter,4.4);
  G.a(0,"");G.a(2,"coco.SetCursor 2, 16");G.a(0,"");G.a(0,"End Sub");
  return G.l;
}
function genMulti(W){
  const m=state.multi,G=new Gen(),U=m.users;
  header(G,"multi-utilisateur",m.ui11!==false);
  if(!U.length)W.push("Aucun utilisateur.");
  if(m.dateMode==="fixed"&&badDate(m.date))W.push("Date invalide (format MMJJ).");
  U.forEach(u=>checkUser(u,W,(u.name||u.mat||"?")+" : "));
  const nm=u=>String(u.name||u.mat||"?").replace(/[|;]/g," ");
  G.a(0,"");G.a(2,"' ===== Questions =====");
  const dateExpr=dateLines(G,2,m.dateMode||"today",m.date);
  if(!U.length){G.a(0,"");G.a(0,"End Sub");return G.l;}
  const items=U.map(u=>nm(u)+";"+padMat(u.mat)).join("|");
  const liste=U.map((u,i)=>`${i+1}-${nm(u)}`).join("  ");
  G.a(0,"");G.a(2,"' Menu a cases a cocher : 1 caractere par personne (1 = cochee)");
  G.a(2,`sel = UiPick(${bbx("Qui faut-il saisir ?")}, ${bbx("Cochez les personnes : elles seront saisies à la suite, dans l'ordre de la liste.")}, ${bbx(items)}, ${bbx(liste)}, ${U.length})`);
  G.a(2,"nb = 0");
  U.forEach((u,i)=>G.a(2,`If Mid(sel, ${i+1}, 1) = "1" Then nb = nb + 1`));
  G.a(2,"If nb = 0 Then");G.a(5,"End");G.a(2,"End If");
  U.forEach((u,i)=>{
    const T=new Gen();prompts(T,u,"u"+(i+1),5);
    if(!T.l.length)return;
    G.a(2,`If Mid(sel, ${i+1}, 1) = "1" Then`);T.l.forEach(l=>G.l.push(l));G.a(2,"End If");
  });
  G.a(0,"");G.a(2,"' ===== Saisie des personnes cochees, a la suite =====");
  U.forEach((u,i)=>{
    G.a(2,`If Mid(sel, ${i+1}, 1) = "1" Then`);
    entry(G,u,"u"+(i+1),5,dateExpr,m.enterSelect?true:"multi",m.delay);
    G.a(2,"End If");
  });
  G.a(0,"");G.a(2,"coco.SetCursor 2, 16");
  const fin=`UiInfo ${bbx("Saisie terminée")}, nb & ${bbx(" fiche(s) saisie(s) et validée(s).")}`;
  if(m.enterSelect)G.a(2,fin);else{G.a(2,"If nb > 1 Then");G.a(5,fin);G.a(2,"End If");}
  G.a(0,"");G.a(0,"End Sub");
  return G.l;
}
function checkUser(u,W,p){
  if(!u.mat)W.push(p+"matricule vide.");
  if(!u.askHours){[["SCHD",u.sched],["ACT",u.act],["END",u.end]].forEach(([n,v])=>{if(!v)W.push(`${p}heure ${n} à remplir.`);else if(badTime(v))W.push(`${p}heure ${n} invalide (HHMM).`);});}
  if(!u.codes.length)W.push(p+"aucun code d'activité.");
  u.codes.forEach(c=>{if(!c.code)W.push(p+"une ligne de code n'a pas de code choisi (ignorée).");if(!c.askTime&&c.time&&badTime(c.time))W.push(`${p}heure du code ${c.code} invalide.`);});
}
let lastScript="";
function regen(){
  if(!$("#code"))return;
  const W=[];
  const lines=state.view==="single"?genSingle(W):genMulti(W);
  lastScript=lines.join("\r\n")+"\r\n";
  $("#code").innerHTML=lines.map(hl).join("\n");
  $("#lc").textContent=lines.length+" lignes";
  $("#warns").innerHTML=W.length?`<div class="warn"><b>À vérifier :</b><ul>${[...new Set(W)].map(w=>`<li>${esc(w)}</li>`).join("")}</ul></div>`:`<div class="okmsg">✔ Script prêt.</div>`;
}
function hl(line){
  if(/^\s*'/.test(line))return `<span class="c">${esc(line)}</span>`;
  return line.split(/("(?:[^"]|"")*")/).map((p,i)=>i%2?`<span class="s">${esc(p)}</span>`:
    esc(p).replace(/\b(If|Then|ElseIf|Else|End|Sub|Dim|As|Object|set)\b/gi,'<span class="k">$1</span>')).join("");
}

/* ===================== Événements ===================== */
const onInput=e=>{
  const p=e.target.dataset.bind;if(!p)return;
  const t=e.target;
  if(t.type==="checkbox"){setP(p,t.checked);save();render();return;}
  if(t.type==="radio"){setP(p,t.value);save();render();return;}
  if(t.tagName==="SELECT"){
    setP(p,t.value);
    if(p.endsWith(".code")){const base=p.slice(0,-5);setP(base+".extra",EXTRA_DEFAULT[t.value]||"");}
    save();render();return;
  }
  let v=t.value;
  if(t.classList.contains("t")){v=v.replace(/\D/g,"");if(v!==t.value)t.value=v;
    const isDate=/\.date$/.test(p);t.classList.toggle("bad",!!v&&(isDate?badDate(v):(!p.endsWith(".extra")&&badTime(v))));}
  setP(p,v);save();
  const m=p.match(/^multi\.users\.(\d+)\.(name|mat)$/);
  if(m){const u=state.multi.users[+m[1]];const el=ROOT.querySelector(`[data-title="${m[1]}"]`);if(el)el.innerHTML=`${esc(u.name||"(sans nom)")}<small>${esc(u.mat)}</small>`;}
  regen();
};
const onClick=e=>{
  const b=e.target.closest("[data-act]");if(!b)return;
  const a=b.dataset.act,i=+b.dataset.i,L=b.dataset.list?getP(b.dataset.list):null;
  if(["uUp","uDown","delUser"].includes(a))e.stopPropagation();
  const U=state.multi.users;
  switch(a){
    case "goto":state.view=b.dataset.view;window.scrollTo(0,0);break;
    case "addCode":L.push(nc("",""));break;
    case "delCode":L.splice(i,1);break;
    case "up":if(i>0)[L[i-1],L[i]]=[L[i],L[i-1]];break;
    case "down":if(i<L.length-1)[L[i+1],L[i]]=[L[i],L[i+1]];break;
    case "sortCodes":L.sort((x,y)=>(x.time||"0000").localeCompare(y.time||"0000"));break;
    case "toggleUser":U[i].open=!U[i].open;break;
    case "uUp":if(i>0)[U[i-1],U[i]]=[U[i],U[i-1]];break;
    case "uDown":if(i<U.length-1)[U[i+1],U[i]]=[U[i],U[i+1]];break;
    case "delUser":if(!confirm(`Supprimer ${U[i].name||U[i].mat} ?`))return;U.splice(i,1);break;
    case "addUser":{
      const n=$("#nName").value.trim(),mt=$("#nMat").value.trim();
      if(!n||!mt){toast("Nom et matricule obligatoires");return;}
      const nu=newUser(n,mt);nu.open=true;U.push(nu);toast(n+" ajouté");break;}
    case "copyCodes":{
      const src=U[i];if(!confirm("Remplacer les codes et heures de tous les autres utilisateurs ?"))return;
      U.forEach((u,j)=>{if(j!==i){u.codes=JSON.parse(JSON.stringify(src.codes));u.sched=src.sched;u.act=src.act;u.end=src.end;u.askHours=src.askHours;}});
      toast("Codes copiés");break;}
    case "dl":{
      let n=($("#fname").value.trim()||"script").replace(/[\\/:*?"<>|]/g,"_");if(!/\.bbs$/i.test(n))n+=".bbs";
      download(n,lastScript);toast("Fichier téléchargé");return;}
    case "copy":
      (navigator.clipboard?navigator.clipboard.writeText(lastScript):Promise.reject()).then(()=>toast("Script copié"),()=>{
        const ta=document.createElement("textarea");ta.value=lastScript;document.body.appendChild(ta);ta.select();document.execCommand("copy");ta.remove();toast("Script copié");});
      return;
    case "export":{const c=JSON.parse(JSON.stringify(state));c.single.pwd="";c.single.pwd2="";download("famis-config.json",JSON.stringify(c,null,2));return;}
    case "import":$("#fileImp").click();return;
    case "preview":previewDlg(b.dataset.k,b.dataset.b);return;
    default:return;
  }
  save();render();
};
const onImport=e=>{
  const f=e.target.files[0];if(!f)return;
  const r=new FileReader();
  r.onload=()=>{try{const s=JSON.parse(r.result);migrate(s.single);migrate(s.multi);Object.assign(state.single,s.single||{});Object.assign(state.multi,s.multi||{});save();render();toast("Configuration importée");}catch(err){toast("Fichier invalide");}};
  r.readAsText(f);e.target.value="";
};
function download(name,text){
  const a=document.createElement("a");a.href=URL.createObjectURL(new Blob([text],{type:"text/plain"}));a.download=name;
  document.body.appendChild(a);a.click();setTimeout(()=>{URL.revokeObjectURL(a.href);a.remove();},500);
}


/* ---------- Fenêtres Windows 11 (même rendu que la fenêtre mshta du script) ---------- */
const W11SVG={
  input:'<path d="M4 16l1-3.5 8.5-8.5 2.5 2.5L7.5 15.5 4 16zM12 5.5l2.5 2.5"/>',
  pwd:'<rect x="5" y="9" width="10" height="7.5" rx="1.5"/><path d="M7 9V7a3 3 0 0 1 6 0v2"/>',
  time:'<circle cx="10" cy="10" r="6.5"/><path d="M10 6.5V10l2.5 1.5"/>',
  date:'<rect x="3.5" y="4.5" width="13" height="12" rx="1.5"/><path d="M3.5 8h13M7 3v3M13 3v3"/>',
  ask:'<circle cx="10" cy="10" r="6.5"/><path d="M8.2 8.2a1.9 1.9 0 1 1 2.6 1.7c-.5.3-.8.7-.8 1.3v.3"/><circle cx="10" cy="13.6" r=".5" fill="currentColor"/>',
  pick:'<circle cx="7.5" cy="7" r="2.5"/><path d="M3 15.5c0-2.5 2-4 4.5-4s4.5 1.5 4.5 4"/><circle cx="13.5" cy="7.5" r="2"/><path d="M13.5 11.5c2 0 3.5 1.2 3.5 3.5"/>',
  info:'<path d="M5 10.5l3 3 7-7"/>'
};
const W11CHK='<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="1.6"><path d="M2.5 6.2l2.3 2.3 4.7-4.8"/></svg>';
const W11MIX='<svg width="12" height="12" viewBox="0 0 12 12" stroke="#fff" stroke-width="1.6"><path d="M3 6h6"/></svg>';
const MOIS=["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],JOURS=["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"];
function w11Dialog(o){
  const k=o.kind,isIn=["input","time","date","pwd"].includes(k),items=o.items||[];
  const btns=k==="ask"?[["Oui","6"],["Non","7"]]:k==="info"?[["OK","1"]]:k==="pick"?[["Saisir","ok"],["Annuler",null]]:[["OK","ok"],["Annuler",null]];
  const xVal=k==="ask"?"7":k==="info"?"1":null;
  let zone="";
  if(isIn)zone=`<input class="tb" id="wI" type="${k==="pwd"?"password":"text"}" ${k==="time"||k==="date"?'maxlength="4" inputmode="numeric"':""} autocomplete="off" value="${esc(o.def??"")}"><div class="hl" id="wH"></div>`;
  if(k==="pick")zone=`<div class="all" id="wAll" tabindex="0"><span class="cb"></span><span class="nm"><b>Tout sélectionner</b></span><span class="mt" id="wCnt"></span></div>
    <div class="lst">${items.map((it,i)=>`<div class="it" tabindex="0" data-i="${i}"><span class="cb"></span><span class="no">${i+1}</span><span class="nm">${esc(it.name)}</span><span class="mt">${esc(it.mat)}</span></div>`).join("")}</div>`;
  const html=`<div class="w11wrap"><div class="w11 ${k}" role="dialog">
    <div class="cap"><span>FAMIS</span><span class="sp"></span><button class="x" data-x title="Fermer">✕</button></div>
    <div class="w11c"><div class="w11h"><span class="ic"><svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${W11SVG[k]||W11SVG.info}</svg></span><h4>${esc(o.title)}</h4></div>
    ${o.text?`<p>${esc(o.text)}</p>`:""}${zone}</div>
    <div class="w11f">${btns.map((b,i)=>`<button data-b="${i}" class="${i?"":"pri"}">${b[0]}</button>`).join("")}</div></div>
    <div class="w11meta">Aperçu de la fenêtre affichée par le script</div></div>`;
  return new Promise(res=>{
    const ov=document.createElement("div");ov.className="famis ov w";ov.innerHTML=html;document.body.appendChild(ov);
    const close=v=>{ov.remove();res(v);};
    const q=s=>ov.querySelector(s);
    const I=q("#wI"),H=q("#wH");let tried=false;
    const chkv=v=>{
      if(k==="time"){if(!/^\d{4}$/.test(v))return "Format HHMM attendu (ex : 0830)";if(+v.slice(0,2)>23||+v.slice(2)>59)return "Heure invalide (0000 à 2359)";}
      if(k==="date"){if(!/^\d{4}$/.test(v))return "Format MMJJ attendu (ex : 1028)";if(badDate(v))return "Date invalide";}
      if(k==="pwd"&&!v)return "Mot de passe obligatoire";return "";};
    const hint=()=>{const v=I.value,e=chkv(v),bad=!!e&&(tried||v.length>=4);let h="";
      if(!e&&k==="time")h="→ "+v.slice(0,2)+":"+v.slice(2);
      if(!e&&k==="date"){const y=new Date().getFullYear(),d=new Date(y,+v.slice(0,2)-1,+v.slice(2));h=`${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]} ${y}`;h="→ "+h[0].toUpperCase()+h.slice(1);}
      if(e&&!bad)h=k==="time"?"Format HHMM, ex : 0830":k==="date"?"Format MMJJ, ex : 1028":"";
      H.className="hl"+(bad?" bad":"");I.className="tb"+(bad?" bad":"");H.textContent=bad?e:h;};
    if(I){I.oninput=()=>{if(k==="time"||k==="date")I.value=I.value.replace(/\D/g,"");hint();};hint();}
    const S=items.map(()=>false),rows=[...ov.querySelectorAll(".it")],all=q("#wAll"),b0=q('[data-b="0"]');
    const upd=()=>{if(k!=="pick")return;const n=S.filter(Boolean).length;
      rows.forEach((r,i)=>{r.classList.toggle("on",S[i]);r.firstElementChild.innerHTML=S[i]?W11CHK:"";});
      all.className="all"+(n===0?"":n===S.length?" on":" mix");all.firstElementChild.innerHTML=n===0?"":n===S.length?W11CHK:W11MIX;
      q("#wCnt").textContent=`${n} / ${S.length}`;b0.textContent=n?`Saisir (${n})`:"Saisir";b0.disabled=!n;};
    const tg=i=>{S[i]=!S[i];upd();},ta=()=>{const v=S.some(x=>!x);S.fill(v);upd();};
    rows.forEach((r,i)=>r.onclick=()=>tg(i));if(all)all.onclick=ta;upd();
    const go=()=>{
      if(I){tried=true;if(chkv(I.value)){hint();I.focus();return;}return close(I.value);}
      if(k==="pick"){if(!S.some(Boolean))return;return close(S.map(x=>x?"1":"0").join(""));}
      close(btns[0][1]);};
    ov.querySelectorAll("[data-b]").forEach(b=>b.onclick=()=>{const i=+b.dataset.b;if(i===0)go();else close(btns[i][1]);});
    q("[data-x]").onclick=()=>close(xVal);
    ov.addEventListener("click",e=>{if(e.target===ov)close(xVal);});
    ov.addEventListener("keydown",e=>{
      if(e.key==="Enter"){e.preventDefault();go();}
      else if(e.key==="Escape"){e.preventDefault();close(k==="ask"?"7":xVal);}
      else if(k==="pick"){
        const a=document.activeElement,idx=a===all?-1:rows.indexOf(a);
        if(e.key===" "&&(a===all||idx>=0)){e.preventDefault();a===all?ta():tg(idx);}
        else if(e.key==="ArrowDown"||e.key==="ArrowUp"){e.preventDefault();let n=idx+(e.key==="ArrowDown"?1:-1);n=Math.max(-1,Math.min(rows.length-1,n));(n<0?all:rows[n]).focus();}
        else if(e.key==="a"&&e.ctrlKey){e.preventDefault();ta();}
      }});
    setTimeout(()=>{if(I){I.focus();I.select();}else if(all)all.focus();else b0.focus();},30);
  });
}
async function previewDlg(k,base){
  const P={preview:true},u0=(state.multi.users[0]||{}),who=base==="multi"?(u0.name||"Intérim 1"):"Feuille de temps";
  if(k==="pick"){
    const U=state.multi.users;
    const items=U.length?U.map(u=>({name:u.name||u.mat,mat:padMat(u.mat)})):[{name:"Dupont",mat:"0000123456"},{name:"Martin",mat:"0000654321"},{name:"Intérim 1",mat:"0000777001"},{name:"Intérim 2",mat:"0000777002"}];
    const v=await w11Dialog({...P,kind:"pick",title:"Qui faut-il saisir ?",text:"Cochez les personnes : elles seront saisies à la suite, dans l'ordre de la liste.",items});
    if(v)toast(`${[...v].filter(c=>c==="1").length} personne(s) seraient saisies`);
  }else if(k==="date"){
    const v=await w11Dialog({...P,kind:"date",title:"Date de la time card",text:"Date à saisir au format MMJJ (aujourd'hui proposé)",def:todayMMJJ()});if(v)toast("Date : "+v);
  }else if(k==="ask"){
    await w11Dialog({...P,kind:"ask",title:who,text:"Saisir le code 035 « Activité Dispatch » ?"});
  }else{
    const v=await w11Dialog({...P,kind:"time",title:who,text:"Heure du code 035 « Activité Dispatch » (HHMM)",def:"0830"});if(v)toast("Heure : "+v);
  }
}


/* ===================== Montage dans la page ===================== */
export function monterFamis(root, notifier){
  ROOT=root; TOAST=notifier||(()=>{});
  root.innerHTML=`<div class="fx-bar">
      <div class="logo" data-act="goto" data-view="home">Fam<b>is</b> Script Studio</div>
      <div class="sub">Générateur de scripts BlueZone · Time Card FS-110</div>
      <div class="sp"></div>
      <button class="btn ghost sm" data-act="export">Exporter config</button>
      <button class="btn ghost sm" data-act="import">Importer config</button>
      <input type="file" id="fileImp" accept=".json" class="hide">
    </div>
    <div id="famis-app"></div>`;
  root.addEventListener("input",onInput);
  root.addEventListener("click",onClick);
  const imp=root.querySelector("#fileImp");imp.addEventListener("change",onImport);
  load();render();
  return ()=>{root.removeEventListener("input",onInput);root.removeEventListener("click",onClick);imp.removeEventListener("change",onImport);
    document.querySelectorAll(".famis.ov").forEach(o=>o.remove());root.innerHTML="";ROOT=null;};
}
